<!-- TODO: Avoid nested if/else in class -->
<button
  [disabled]="disabled"
  class="  {{ classContent }}
        hover:brightness-90
        flex flex-row gap-3 justify-center items-center
        btn-{{ type }}
        {{ size }}
        {{
    !disabled ? 'kiosk:active:scale-105 kiosk:transition-transform kiosk:duration-100' : ''
  }}
        {{ type === 'outlined' && color ? 'border-' + color + '-300 text-' + color + '-600' : '' }}
                {{
    type === 'kiosk-outlined'
      ? 'text-' + colorFieldRawValue(overrideTextColor) + ' rounded-lg font-bold border-4'
      : ''
  }}
        {{ type === 'light' && !hasColorFieldValue(overrideBgColor) ? 'bg-' + color + '-100' : '' }}
        {{
    type === 'light' && !hasColorFieldValue(overrideTextColor) ? 'text-' + color + '-600' : ''
  }}
        {{ type === 'kiosk-primary' ? 'rounded-lg font-bold' : null }}
        {{ type === 'kiosk-light' ? 'rounded-lg font-bold' : null }}
        {{
    type === 'light' && color === 'neutral' && !hasColorFieldValue(overrideTextColor)
      ? 'text-' + color + '-800'
      : ''
  }}
        {{ type === 'link' ? 'text-primary-800' : '' }}
        {{ type === 'link' && !hasColorFieldValue(overrideBgColor) ? 'bg-transparent' : '' }}
        {{ type === 'kiosk-outlined' && size === 'XXL' ? 'text-3xl' : '' }}
        {{
    thickSize === 'XS'
      ? 'py-1'
      : thickSize === 'S'
        ? type === 'kiosk-primary' || type === 'kiosk-light'
          ? 'py-1.5 !text-xl'
          : 'py-2'
        : thickSize === 'M'
          ? 'py-3.5'
          : thickSize === 'L'
            ? 'py-4'
            : thickSize === 'XXL'
              ? type === 'kiosk-primary' || type === 'kiosk-light' || type === 'kiosk-outlined'
                ? 'py-7.5 !text-4xl'
                : 'py-8'
              : ''
  }}
"
  [style.border-color]="type === 'kiosk-outlined' ? colorFieldRawValue(overrideTextColor) : ''"
  [style.backgroundColor]="overrideBgColor | contentBuilderColor"
  [style.color]="overrideTextColor | contentBuilderColor"
  [class.disabled]="disabled || lookDisabled"
  [class.aspect-square]="aspectSquare"
  [class.w-full]="full"
  (click)="clickEventEmitter.emit($event)"
>
  @if (icon && !iconOnRight) {
    <i class="icon {{ icon }} rotate-{{ iconRotation }}"></i>
  }
  @if (iconUrl && !iconOnRight) {
    <img src="{{ iconUrl }}" />
  }
  @if (label) {
    <span [textContent]="label"></span>
  }
  @if (icon && iconOnRight) {
    <i class="icon {{ icon }}"></i>
  }
</button>
